import { dynamicLengthValidator } from '../../../common/Utils/Utils';
import {
  confirmPasswordValidator,
  emailValidator,
  passwordValidator,
  internationalPhoneValidator,
} from '../../../common/Validators/Validators';

// registerForm
export const RegisterFormField = (form, isCustom, countryCode = '+91') => [
  {
    label: 'Full Name',
    field: 'firstName',
    span: 24,
    maxLength: 50,
    type: 'text',
    placeholder: 'Enter your full name',
    required: true,
    rules: [
      { required: true, message: 'First Name is required' },
      {
        validator: dynamicLengthValidator(3, 'First Name'),
      },
    ],
  },
  // {
  //   label: 'Last Name',
  //   field: 'lastName',
  //   span: 12,
  //   type: 'text',
  //   maxLength: 50,
  //   placeholder: 'Enter your last name',
  //   required: true,
  //   rules: [
  //     { required: true, message: 'Last Name is required' },
  //     // {
  //     //   validator: dynamicLengthValidator(3, 'Last Name'),
  //     // },
  //   ],
  // },
  {
    label: 'Company Name',
    field: 'company',
    span: 24,
    type: 'text',
    maxLength: 100,
    placeholder: 'Enter your company name',
    required: true,
    rules: [
      { required: true, message: 'Company Name is required' },
      {
        validator: dynamicLengthValidator(2, 'Company Name'),
      },
    ],
  },
  {
    label: 'Email',
    field: 'email',
    span: 12,
    maxLength: 254,
    type: 'text',
    placeholder: 'Enter your email',
    required: true,
    rules: [
      { required: true, message: 'Email is required' },
      {
        validator: dynamicLengthValidator(6, 'Email'),
      },
      emailValidator('Please enter a valid email'),
    ],
  },
  {
    label: 'Mobile Number',
    field: 'phoneNumber',
    span: 12,
    type: 'number',
    maxLength: 15,
    placeholder: 'Enter your mobile number',
    required: true,
    allowClear: true,
    rules: [
      { required: true, message: 'Mobile number is required' },
      { validator: internationalPhoneValidator(countryCode) },
    ],
  },
  {
    field: 'password',
    label: 'Password',
    span: 12,
    maxLength: 15,
    type: 'password',
    required: true,
    placeholder: 'Enter your password',
    rules: [{ validator: passwordValidator }],
  },
  {
    field: 'confirmPassword',
    label: 'Confirm Password',
    span: 12,
    maxLength: 15,
    type: 'password',
    required: true,
    placeholder: 'Re-enter your password',
    rules: [
      {
        validator: (value, callback) => {
          confirmPasswordValidator(
            value,
            callback,
            form.getFieldValue('password')
          );
        },
      },
    ],
  },
  ...(isCustom
    ? [
        {
          field: 'customerRequirement',
          label: 'Custom Message',
          type: 'textarea',
          span: 24,
          required: true,
          placeholder: 'Enter your message here...',
          rules: [
            { required: true, message: 'Custom Message is required' },
            {
              validator: dynamicLengthValidator(3, 'Custom Message'),
            },
          ],
        },
      ]
    : []),
];
